import { module } from "../app";
import * as commonConstants from '../constants/constantStrings';

module.directive('followUpPatientDetails', [ 
  'modalService', 'Patient', '$ionicLoading', 'signalrService', 'ageHelper',
  function (modalService, Patient, $ionicLoading, signalrService, ageHelper) {
    return {
      restrict: "E",
      templateUrl: "views/templates/followUpPatientDetails.html",
      scope: {
        patientAccessToken: "=",
        clip: "="
      },
      link: async function (scope, element, ngModel) {

        scope.getPatientFullName = () => {
          if (!scope.patientDetails) {
            return '';
          }
          const lastName = scope.patientDetails.LastName || '';
          const firstName = scope.patientDetails.FirstName || '';
          const fullName = `${lastName}, ${firstName}`;
          return fullName;
        }

        scope.formatDateString = (dateString) => {
          const date = new Date(dateString);
          const formattedDate = `${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}`;
          return formattedDate;
        }

        scope.getPatientAgeAndDobString = () => {
          if (!scope.patientDetails || !scope.patientDetails.DOB) {
            return '';
          }
          const formattedDob = scope.formatDateString(scope.patientDetails.DOB);
          const age = scope.getPatientsAge();
          const ageAndDobString = `Age: ${age}, ${formattedDob}`;

          return ageAndDobString;
        }

        scope.getPatientsAge = () => {
          let patientsAge = '';

          if (scope.patientDetails && scope.patientDetails.DOB) {
            let dateOfBirth = new Date(scope.patientDetails.DOB);
            patientsAge = ageHelper.getAgeFromBirthDate(dateOfBirth);
          }

          return patientsAge;
        }

        scope.loadPatientData = async () => {
          if (!signalrService.isConnected) {
            await modalService.showAlertAsync(commonConstants.OFFLINE_ERROR_MESSAGE);
            return;
          }

          try {
            const resp = await Patient.getPatientDemographicsByAccessToken(scope.patientAccessToken);
            scope.patientDetails = resp.data;
          } catch (errorResponse) {
            $ionicLoading.hide();
            modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_LOAD_PATIENT_DATA_ERROR_MESSAGE);
          }          
        };

        scope.initialize = async () => {
          await scope.loadPatientData();
          
          if (scope.patientDetails) {
            scope.patientFullName = scope.getPatientFullName();
            scope.patientAgeAndDobString = scope.getPatientAgeAndDobString();
          } else {
            scope.patientFullName = '';
            scope.patientAgeAndDobString = '';
          }
        }

        scope.showPatClipPopup = async () => {
          const clipData = (scope.clip || {}).Flag;
          await modalService.showAlertAsync(clipData);
        };

        await scope.initialize();
      }
    };
  }]);


// WEBPACK FOOTER //
// ./src/scripts/directives/follow-up-patient-details.js